<template>
    <div>
        <app-nav/>
        <main class="mb-3">
            <section>
                <div class="row d-flex justify-content-center m-0 p-0">
                    <div class="col taust w-100">
                        <div class="row d-flex mob-bg justify-content-center m-0 p-0 wow fadeIn">
                            <div class="col top-m-p text-center w-100">
                                <h1 class="display-5 font-weight-normal my-3">
                                    {{ $t('Rent a car, van or minivan') }}
                                </h1>
                            </div>
                        </div>
                        <div class="container white pt-2">
                            <validation-observer v-slot="{ validate }" slim>
                                <form @submit.prevent="search(validate)">
                                    <div class="row frontpage-vorm justify-content-center wow fadeIn">
                                        <div class="col-xl-5 col-md-6">
                                            <app-datepicker id="search_dates"
                                                            v-model="search_dates"
                                                            range
                                                            disabledBeforeToday
                                                            name="search_dates"
                                                            rules="required">
                                                <template #label>
                                                    {{ $t('Start date') }} & {{ $t('Return date') }}*
                                                </template>
                                            </app-datepicker>
                                            <div class="row">
                                                <div class="col-xl-6 col-lg-6 col-md-12">
                                                    <div class="mb-4 w-100">
                                                        <app-select id="transmission_id"
                                                                    v-model="search_form.transmission_id"
                                                                    :options="params.transmissions.map(c => c.id)"
                                                                    :placeholder="$t('All')"
                                                                    name="transmission_id"
                                                                    openDirection="bottom"
                                                                    closeOnSelect
                                                                    :custom-label="id => params.transmissions.some(c => c.id === id) ? $t(params.transmissions.find(c => c.id === id).name) : null">
                                                            <template #label>
                                                                {{ $t('Transmission') }}
                                                            </template>
                                                        </app-select>
                                                    </div>
                                                </div>
                                                <div class="col-xl-6 col-lg-6 col-md-12">
                                                    <div class="mb-4 w-100">
                                                        <app-select id="fuel_id"
                                                                    v-model="search_form.fuel_id"
                                                                    :options="params.fuels.map(c => c.id)"
                                                                    :placeholder="$t('All')"
                                                                    name="fuel_id"
                                                                    openDirection="bottom"
                                                                    closeOnSelect
                                                                    :custom-label="id => params.fuels.some(c => c.id === id) ? $t(params.fuels.find(c => c.id === id).name) : null">
                                                            <template #label>
                                                                {{ $t('Fuel') }}
                                                            </template>
                                                        </app-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 mb-4 ">
                                            <div class="vorm-paremal">
                                                <div class="mb-2 w-100">
                                                    <app-select id="type_id"
                                                                v-model="search_form.type_id"
                                                                :options="params.types.map(c => c.id)"
                                                                :placeholder="$t('All')"
                                                                name="type_id"
                                                                openDirection="bottom"
                                                                closeOnSelect
                                                                :custom-label="id => params.types.some(c => c.id === id) ? $t(params.types.find(c => c.id === id).name) : null">
                                                        <template #label>
                                                            {{ $t('Type') }}
                                                        </template>
                                                    </app-select>
                                                </div>
                                                <app-button :loading="loading" class="btn btn-autorent waves-effect waves-light w-100 mb-0 mt-3">
                                                    {{ $t('Search') }}
                                                </app-button>
                                            </div>
                                        </div>
                                        <div v-if="no_results" class="alert alert-warning alert-dismissible fade show" role="alert">
                                            {{ $t('No available vehicles, please choose other dates') }}
                                            <button type="button" class="close" @click="no_results = false">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </validation-observer>
                            <hr>
                            <div class="container text-left" style="min-height: 30vh">
                                <div v-if="page_times" v-html="page_times[locale]"/>

                                <p v-if="locale === 'et'">
                                    Kas Teid huvitab
                                    <span @click="pricelistRedirect('prices.car')" class="btn-link primary pointer">sõiduauto</span>,
                                    <span @click="pricelistRedirect('prices.minibus')" class="btn-link primary pointer">väikebussi</span>,
                                    <span @click="pricelistRedirect('prices.commercial.vehicle')" class="btn-link primary pointer">kaubiku</span>
                                    või
                                    <span @click="pricelistRedirect('prices.eqs')" class="btn-link primary pointer">lisavarustuse</span>
                                    rent? Kui jah, siis olete täpselt õiges kohas!
                                </p>

                                <p v-if="locale === 'en'">
                                    Are you interested in renting
                                    <span @click="pricelistRedirect('prices.car')" class="btn-link primary pointer">a car</span>,
                                    <span @click="pricelistRedirect('prices.minibus')" class="btn-link primary pointer">passenger van</span>,
                                    <span @click="pricelistRedirect('prices.commercial.vehicle')" class="btn-link primary pointer">cargo van</span>
                                    or
                                    <span @click="pricelistRedirect('prices.eqs')" class="btn-link primary pointer">accessories</span>
                                    ? If so, you are exactly in the right place!
                                </p>

                                <div v-if="page" v-html="page[locale]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <app-search-results v-if="results.length" :search_form="search_form" :results="results" @resetFrom="resetFrom"/>
        </main>
        <app-footer/>
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import AppSearchResults from '@views/Landing/components/SearchResults';
import PublicSettingsService from '@services/publicSettings.service';
import PublicBookingService from '@services/publicBooking.service';
import {mapGetters} from 'vuex';
import PublicPageService from '@services/publicPage.service';

export default {
    data() {
        return {
            search_dates: [],
            search_form: {
                start_date: null,
                end_date: null,
                type_id: null,
                transmission_id: null,
                fuel_id: null
            },
            params: {
                types: [],
                fuels: [],
                transmissions: [],
                drivetrains: []
            },
            results: [],
            loading: false,
            no_results: false,
            page: null,
            page_times: null,
        };
    },
    computed: {
        ...mapGetters(['locale']),
    },
    watch: {
        locale() {
            this.resetFrom();
        }
    },
    components: {
        AppNav,
        AppFooter,
        AppSearchResults
    },
    methods: {
        pricelistRedirect(type) {
            localStorage.setItem('pricelist_route', type);
            this.$router.push({ name: 'prices' });
        },
        getPage() {
            PublicPageService.publicShow('home').then(res => {
                this.page = res;
            });
        },
        getPageTimes() {
            PublicPageService.publicShow('home times').then(res => {
                this.page_times = res;
            });
        },
        resetFrom() {
            this.results = [];
            this.search_dates = [];
            this.search_form = {
                type_id: null,
                transmission_id: null,
                fuel_id: null
            };
        },
        getParams() {
            PublicSettingsService.params().then(res => this.params = res);
        },
        urlQuerySearch() {
            this.loading = true;
            this.search_form.start_date = this.search_dates[0];
            this.search_form.end_date = this.search_dates[1];
            PublicBookingService.search(this.search_form).then(res => {
                if(!res.length) {
                    this.no_results = true;
                } else {
                    setTimeout(() => {
                        this.$scrollTo('#results', 500, {});
                    }, 100);
                }
                this.loading = false;
                this.results = res;

                let queryObj = {};
                if(this.search_form.start_date) {
                    queryObj.start_date = this.search_form.start_date;
                }
                if(this.search_form.end_date) {
                    queryObj.end_date = this.search_form.end_date;
                }
                if(this.search_form.type_id) {
                    queryObj.type_id = this.search_form.type_id;
                }
                if(this.search_form.transmission_id) {
                    queryObj.transmission_id = this.search_form.transmission_id;
                }
                if(this.search_form.fuel_id) {
                    queryObj.fuel_id = this.search_form.fuel_id;
                }
                this.$router.replace({ path: '/', query: queryObj }).catch(err => {});
            }).catch(e => this.loading = false);
        },
        search(validate) {
            this.results = [];
            this.no_results = false;
            validate().then(valid => {
                if (valid) {
                    this.search_form.start_date = this.search_dates[0];
                    this.search_form.end_date = this.search_dates[1];
                    this.urlQuerySearch();
                }
            });
        }
    },
    created() {
        this.getParams();
        this.getPageTimes();
        this.getPage();
        this.search_dates = [this.$route.query.start_date, this.$route.query.end_date];
        this.search_form.type_id = this.$route.query.type_id ? parseInt(this.$route.query.type_id) : null;
        this.search_form.transmission_id = this.$route.query.transmission_id ? parseInt(this.$route.query.transmission_id) : null;
        this.search_form.fuel_id = this.$route.query.fuel_id ? parseInt(this.$route.query.fuel_id) : null;
        if (this.$route.query.start_date && this.$route.query.end_date) {
            this.urlQuerySearch();
        }
        localStorage.removeItem('pricelist_route');
    },
    metaInfo() {
        return {
            title: `${this.$t('Cheap Car Rental')} | Autorent OÜ`,
            meta: [
                { name: 'Description', content: '1Autorent - Autorent OÜ - pakume kvaliteetset ning soodsa hinnaga autorenditeenust Tallinnas, pakume väikebusside ja sõiduautode rentimist!' },
                { property: 'Keywords', content: 'auto, väikebusside, sõiduautode, rentimine, autorent oü, soodsam, hinnad, soodne, 1autorent' },
                { property: 'contactName', content: '1autorent' },
                { property: 'contactPhoneNumber', content: '+372 53 555 999' },
                { property: 'contactNetworkAddress', content: 'info [t] 1autorent.ee' },
                { property: 'author', content: '1autorent | info [t] 1autorent.ee' },
                { property: 'copyright', content: 'Copyright (c) 2021 1autorent.ee' },
                { property: 'identifier-url', content: 'https://www.1autorent.ee/' },
                { property: 'linkage', content: 'https://www.1autorent.ee/' },
                { property: 'content-owner', content: '1autorent.ee' },
                { property: 'publisher', content: '1autorent.ee' },
                { property: 'contact', content: '1autorent.ee' },
                { property: 'distribution', content: 'global' },
                { property: 'coverage', content: 'global' },
                { property: 'rating', content: 'general' },
                { property: 'class', content: 'open' },
                { property: 'robots', content: 'index, follow' },
                { property: 'ROBOTS', content: 'ALL' },
                { property: 'expires', content: 'never' },
                { property: 'revisit-after', content: '3 days' }
            ]
        };
    }
};
</script>
